<template>
  <v-container fluid="" pa-0="">
    <v-row align="center" justify="center">
      <v-img max-height="205" max-width="135" src="@/assets/take_break_coffee.svg"></v-img>
    </v-row>
    <v-row justify="center">
      <page-heading class="my-5" :text="$t('pause.break_title')"></page-heading>
    </v-row>
    <v-row justify="center">
      <v-col class="text-center" cols="7">
        {{$t('pause.break_desc')}}
      </v-col>
    </v-row>
    <v-row justify="center" v-if="error">
      <v-col class="text-center" cols="7">
        <v-alert color="error">{{$t(error)}}</v-alert>
      </v-col>
    </v-row>
    <transition name="fade">
      <v-row justify="center" v-if="showVerify && !loading">
        <div>
          <small>{{$t('pause.pin')}}</small>
          <otp-inputs @submit="submitOtp($event)"></otp-inputs>
        </div>
      </v-row>
      <v-row justify="center" align="center" v-else-if="loading" style="min-height:98px">
       <v-progress-circular :indeterminate="true" color="white"></v-progress-circular>
      </v-row>
    </transition>
    <v-row justify="center">
      <span class="pt-3">
         <v-btn @click="sendVerification()"
                color="grey"
                class="ma-1"
                large
         >{{$t(!showVerify ? 'general.continue' : 'components.otp.form_actions.resend_button_text')}}
      </v-btn>
        <v-btn @click="quit()"
                color="secondary"
                class="ma-1"
                large
         >{{$t('pause.quit')}}
      </v-btn>
      </span>

    </v-row>
  </v-container>
</template>

<script>
    import PageHeading from "../PageHeading";
    import OtpInputs from "../../auth/OtpInputs";

    export default {
        components: {
            PageHeading,
            OtpInputs
        },
        name: "TakeBreakState",
        data(){
          return {
            showVerify : false,
            loading : false,
            error : null
          }
        },
        methods: {
            sendVerification(){
              this.loading=true;
              this.error=null;
              this.$store.dispatch('auth/sendBreakOtp').then(()=>{
                this.showVerify=true;
                this.loading=false;
              }).catch((err)=>{
                this.loading=false;
                this.error='errors.'+(err.response.data.message || 'unknown');
              });
            },
            submitOtp(otp) {
                this.loading=true;
                this.error=null;
                this.$store.dispatch('auth/verifyBreakOtp',otp).catch((err)=>{
                  this.loading=false;
                  this.error='errors.'+(err.response.data.message || 'unknown');
                });
            },
            quit(){
              this.$store.dispatch('auth/logout',{
                navigate:true,
                clearAssessmenttoken: true
              });
            }
        }
    }
</script>

<style scoped>

</style>